<template>
  <b-container id="registration">
    <div class="container container--max-810">
      <div class="px-4">
        <div class="c-topbar-content c-topbar-content--compensate-borders">
          <div class="c-topbar-content__left">
            <mtg-header-link></mtg-header-link>
          </div>
        </div>
      </div>
    </div>
    <b-form @submit.prevent="onSubmit" novalidate>
      <div class="container container--max-810 mt-3 mt-md-4">
        <b-card>
          <h1 class="h3 mb-6">{{ $t("lang.label_registration_createAccount") }}</h1>
          <div class="row">
            <b-form-group :label="$t('lang.label_registration_firstName')" label-for="firstName" class="col-md-6 asterisk-label">
              <b-form-input v-model="userDto.firstName" id="firstname" type="text" required :placeholder="$t('lang.label_placeholder_firstName')"></b-form-input>
              <b-form-invalid-feedback>{{ $t("lang.label_registration_firstName_feedback") }}</b-form-invalid-feedback>
            </b-form-group>
            <b-form-group :label="$t('lang.label_registration_lastName')" label-for="lastName" class="col-md-6 asterisk-label">
              <b-form-input v-model="userDto.lastName" id="lastname" type="text" required :placeholder="$t('lang.label_placeholder_lastName')"></b-form-input>
              <b-form-invalid-feedback>{{ $t("lang.label_registration_lastName_feedback") }}</b-form-invalid-feedback>
            </b-form-group>
            <b-form-group :label="$t('lang.label_email')" label-for="email" class="col-lg-6 asterisk-label">
              <b-form-input v-model="userDto.email" id="email" type="email" required :placeholder="$t('lang.label_placeholder_email')"></b-form-input>
              <b-form-invalid-feedback>{{ $t("lang.label_email_feedback") }}</b-form-invalid-feedback>
            </b-form-group>
            <b-form-group :label="$t('lang.label_registration_orgName')" label-for="company" class="col-lg-6 asterisk-label">
              <b-form-input v-model="userDto.orgName" id="company" type="text" required :placeholder="$t('lang.label_placeholder_company')"></b-form-input>
              <b-form-invalid-feedback>{{ $t("lang.label_organisation_feedback") }}</b-form-invalid-feedback>
            </b-form-group>
            <b-form-group :label="$t('lang.label_registration_country')" label-for="country" class="col-lg-6 asterisk-label">
              <b-form-input v-model="userDto.country" id="country" type="text" required :placeholder="$t('lang.label_placeholder_company')"></b-form-input>
              <b-form-invalid-feedback>{{ $t("lang.label_organisation_feedback") }}</b-form-invalid-feedback>
            </b-form-group>
            <b-form-group :label="$t('lang.label_password')" label-for="password" class="col-md-6 asterisk-label">
              <b-form-input
                @keydown.space.prevent
                v-model="password"
                id="password"
                ref="password"
                type="password"
                required
                minlength="8"
                :placeholder="$t('lang.label_placeholder_password')"
                v-b-tooltip.hover
                :title="$t('lang.tooltip_user_password')"
              ></b-form-input>
              <b-form-invalid-feedback>{{ customPasswordErrorMessage }}</b-form-invalid-feedback>
            </b-form-group>
            <b-form-group :label="$t('lang.label_password_confirm')" label-for="password-confirmation" class="col-md-6 asterisk-label">
              <b-form-input
                @keydown.space.prevent
                v-model="passwordConfirmation"
                id="password-confirmation"
                ref="passwordConfirmation"
                type="password"
                required
                minlength="8"
                :placeholder="$t('lang.label_placeholder_password')"
              ></b-form-input>
              <b-form-invalid-feedback>{{ customPasswordConfirmationMessage }}</b-form-invalid-feedback>
            </b-form-group>
            <b-form-group :label="$t('lang.label_registration_platform')" label-for="plans" class="col-md-6">
              <b-form-select v-model="userUsageClaim" class="mb-3" id="plans" :options="plansOptions"></b-form-select>
            </b-form-group>
            <b-form-group class="col-12">
              <div class="custom-control custom-checkbox">
                <input class="custom-control-input" id="terms-and-conditions" type="checkbox"  required @change="validateElement($event.target)"/>
                <label class="custom-control-label no-color test" for="terms-and-conditions">
                  <span>{{ $t("lang.label_registration_agree") }}</span>
                  <router-link :to="{ name: 'terms-conditions', params: { previousPage: 'register' }  }">{{ $t("lang.label_registration_termsConditions") }}</router-link>
                  <span>.</span>
                </label>
              </div>
            </b-form-group>
          </div>
          <b-row class="mt-2">
            <b-col sm>
              <p>
                <span>{{ $t("lang.label_registration_alreadyHaveAccount") }}</span>
                <br />
                <router-link :to="{ name: 'login' }">{{ $t("lang.label_signIn") }}</router-link>
              </p>
            </b-col>
            <b-col sm class="text-right">
              <b-button id="submit_registration" type="submit" size="lg" variant="primary" :disabled="isLoading">{{ $t("lang.label_register") }}</b-button>
            </b-col>
          </b-row>
          <div>{{ $t("lang.label_star_explained") }}</div>
        </b-card>
      </div>

    </b-form>
  </b-container>
</template>
<script>
import MtgHeaderLink from "../components/layout/MtgHeaderLink";
import * as utils from "@/utils";
import API from "@/api";

export default {
  name: "UserRegistration",
  components: {
    MtgHeaderLink
  },
  data() {
    return {
      userDto: {
        lastName: "",
        orgName: "",
        firstName: "",
        country: "",
        email: this.$route.params.givenEmail,
        isUsing2FA: false
      },
      password: "",
      passwordConfirmation: "",
      userUsageClaim: "0",
      selected: "0",
      plansOptions: [
        {
          text: this.$t("lang.label_pleaseChoose"),
          value: "0"
        }
      ]
    };
  },
  computed: {
    isLoading() {
      return this.$store.getters["isLoading"];
    },
    customPasswordErrorMessage() {
      if (utils.isEmpty(this.password)) {
        return this.$t("lang.message_user_password_error_invalid");
      } else if (!utils.isOfSufficientLength(this.password, 8)) {
        return this.$t("lang.message_user_password_length_error");
        // eslint-disable-next-line no-useless-escape
      } else if (!utils.passwordPatternMatch(this.password)) {
        return this.$t("lang.message_user_password_must_contain_number_letter_and_special_character");
      } else {
        return "";
      }
    },
    customPasswordConfirmationMessage() {
      if (utils.isEmpty(this.passwordConfirmation)) {
        return this.$t("lang.message_user_passwordConfirmation");
      } else if (!utils.isEqual(this.passwordConfirmation, this.password)) {
        return this.$t("lang.message_user_password_error_match");
      } else {
        return "";
      }
    }
  },
  methods: {
    register() {
      let email = this.userDto.email;
      this.$store
        .dispatch("auth/register", { password: this.password, userDto: this.userDto, userUsageClaim: this.userUsageClaim })
        .then(() => {
          this.$router.push({ name: "email-verification", params: { email: email, firstUse: true } });
        })
        .catch(err => {
          var error = err.response.data;
          if (error.message !=null && error.message.includes("There is an account with that email address")) {
            this.$store.dispatch("alert/showFailureAlert", this.$t("lang.label_user_registration_email_already_exist_error"));
          } else {
            this.$store.dispatch("alert/showFailureAlert", this.$t("lang.label_user_registration_error"));
          }
        });
    },
    onSubmit(evt) {
      if (this.validateForm(evt)) {
        this.register();
      }
    },
    validateForm(evt) {
      var isValid = true;
      var elements = evt.target.elements;
      for (let elem of elements) {
        isValid = this.validateElement(elem);
      }
      return isValid;
    },
    validateElement(element)
    {
      var isValid = true;
      utils.resetValidityClassFromElement(element); // remove valid or invalid class before start validating
      if (!element.validity.valid && !element.classList.contains("no-color"))
      {
        element.classList.add("is-invalid");
        isValid = false;
      }
      return isValid;
    },
    updatePasswordValidity() {
      const passwordElement = this.$refs.password;
      utils.resetValidityClassFromElement(passwordElement.$el);
      passwordElement.setCustomValidity(this.customPasswordErrorMessage);
      if (utils.isNotEmpty(this.customPasswordErrorMessage)) {
        passwordElement.$el.classList.add("is-invalid");
      }
    },
    updatePasswordConfirmationValidity() {
      const passwordConfirmationElement = this.$refs.passwordConfirmation;
      utils.resetValidityClassFromElement(passwordConfirmationElement.$el);
      passwordConfirmationElement.setCustomValidity(this.customPasswordConfirmationMessage);
      if (utils.isNotEmpty(this.customPasswordConfirmationMessage)) {
        passwordConfirmationElement.$el.classList.add("is-invalid");
      }
    },
    populateUserPlanDropdown() {
      API.getUserUsageClaimValues()
        .then(response => {
          response.data.forEach(option => {
            this.plansOptions.push(option);
          });
        })
        .catch(() => {});
    }
  },
  watch: {
    password: function() {
      this.updatePasswordValidity();
    },
    passwordConfirmation: function() {
      this.updatePasswordConfirmationValidity();
    }
  },
  mounted() {
    this.populateUserPlanDropdown();
  }
};
</script>
<style scoped></style>
